import { trackerLog } from '@enuygun/frontend-components'
import { getAnalyticsRequestId } from 'utils/analyticsRequestId'

export const HOMEPAGE_REF_VARIANT_B = 'homepage_b'

export function resolveHomepageSearchRef(variant?: string): string {
    return variant === 'B' ? HOMEPAGE_REF_VARIANT_B : 'homepage'
}

export function logHomepageSearchFormSubmit(params: { variant?: string; productCategory: string }): void {
    trackerLog({
        category: 'enuygun-homepage',
        page: 'enuygun-homepage',
        type: 'search_form_submit',
        event: 'search_form_search_submit',
        message: 'Search form search submitted',
        search_form_variant: params.variant?.toLowerCase() || 'a',
        product_category: params.productCategory,
        requestId: getAnalyticsRequestId(),
    })
}
